module.exports = __webpack_public_path__ + "static/img/ent-detail-46.a172be5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-46.jpg
// module id = 4nVp
// module chunks = 52